export enum DeviceType {
    phone = 0,
    sms = 1,
    email = 2,
}
